import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const surveySessionService = {
    // Template sessions - Operatore/Admin
    getTemplates,
    getTemplatesInarray,
    getTemplatesAdmin,
    createTemplate,
    updateTemplate,
    deleteTemplate,
    getTemplate,
    addSurveyToTemplate,
    reorderTemplate,
    startSession,
    getAvailableSurveys,
    
    // Filled sessions - Operatore/Admin
    getFilledSessions,
    getFilledSessionsByTemplate,
    createFilledSession,
    updateFilledSession,
    deleteFilledSession,
    getFilledSession,
    startFilledSession,
    getSessionProgress,
    submitSurveyInSession,
    
    // User filled sessions
    getUserFilledSessions,
    getUserFilledSession,
    getUserSessionProgress,
    submitUserSurvey,
    getFilledSessionsByUser,
};

// === TEMPLATE SESSIONS - OPERATORE/ADMIN METHODS ===

function getTemplates(filters = {}) {
    var sett = { headers: authHeader(), params: filters };
    return axios
        .get("companies/own/survey-sessions", sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function getTemplatesInarray(filters = {}) {
    var sett = { headers: authHeader(), params: filters };
    return axios
        .get("survey-sessions", sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function getTemplatesAdmin(filters = {}) {
    var sett = { headers: authHeader(), params: filters };
    return axios
        .get("survey-sessions", sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function createTemplate(data) {
    var sett = { headers: authHeader() };
    return axios
        .post("survey-sessions", data, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function getTemplate(templateId) {
    var sett = { headers: authHeader() };
    return axios
        .get(`companies/own/survey-sessions/${templateId}`, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function updateTemplate(templateId, data) {
    var sett = { headers: authHeader() };
    return axios
        .put(`survey-sessions/${templateId}`, data, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function deleteTemplate(templateId) {
    var sett = { headers: authHeader() };
    return axios
        .delete(`survey-sessions/${templateId}`, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function addSurveyToTemplate(templateId, surveys) {
    var sett = { headers: authHeader() };
    return axios
        .post(`survey-sessions/${templateId}/add-survey`, { surveys }, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function reorderTemplate(templateId, orderedItems) {
    var sett = { headers: authHeader() };
    return axios
        .put(`survey-sessions/${templateId}/reorder`, { ordered_items: orderedItems }, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function getAvailableSurveys(filters = {}) {
    var sett = { headers: authHeader(), params: filters };
    return axios
        .get("survey-sessions/available-surveys", sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function startSession(sessionTemplateId, data = {}) {
    var sett = { headers: authHeader() };
    return axios
        .post("companies/own/filled-survey-sessions/start", { 
            survey_session_id: sessionTemplateId,
            ...data
        }, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

// === FILLED SESSIONS - OPERATORE/ADMIN METHODS ===

function getFilledSessions(filters = {}) {
    var sett = { headers: authHeader(), params: filters };
    return axios
        .get("companies/own/filled-survey-sessions", sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function getFilledSessionsByTemplate(templateId, filters = {}) {
    var sett = { headers: authHeader(), params: filters };
    return axios
        .get(`survey-sessions/${templateId}/filled-sessions`, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function getFilledSessionsByUser(userHashid, filters = {}) {
    var sett = { headers: authHeader(), params: filters };
    return axios
        .get(`companies/own/filled-survey-sessions/user/${userHashid}`, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function createFilledSession(data) {
    var sett = { headers: authHeader() };
    return axios
        .post("companies/own/filled-survey-sessions", data, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function getFilledSession(sessionId) {
    var sett = { headers: authHeader() };
    return axios
        .get(`companies/own/filled-survey-sessions/${sessionId}`, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function updateFilledSession(sessionId, data) {
    var sett = { headers: authHeader() };
    return axios
        .put(`companies/own/filled-survey-sessions/${sessionId}`, data, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function deleteFilledSession(sessionId) {
    var sett = { headers: authHeader() };
    return axios
        .delete(`companies/own/filled-survey-sessions/${sessionId}`, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function startFilledSession(data) {
    var sett = { headers: authHeader() };
    return axios
        .post("companies/own/filled-survey-sessions/start", data, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function getSessionProgress(sessionId) {
    var sett = { headers: authHeader() };
    return axios
        .get(`companies/own/filled-survey-sessions/${sessionId}/progress`, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function submitSurveyInSession(sessionId, surveyId, filledSurveyId) {
    var sett = { headers: authHeader() };
    return axios
        .post(`users/own/filled-survey-sessions/${sessionId}/submit-survey`, {
            survey_id: surveyId,
            filled_survey_id: filledSurveyId
        }, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

// === USER FILLED SESSIONS METHODS ===

function getUserFilledSessions(filters = {}) {
    var sett = { headers: authHeader(), params: filters };
    return axios
        .get("users/own/filled-survey-sessions", sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function getUserFilledSession(sessionId) {
    var sett = { headers: authHeader() };
    return axios
        .get(`users/own/filled-survey-sessions/${sessionId}`, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function getUserSessionProgress(sessionId) {
    var sett = { headers: authHeader() };
    return axios
        .get(`users/own/filled-survey-sessions/${sessionId}/progress`, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}

function submitUserSurvey(sessionId, surveyId, filledSurveyId) {
    var sett = { headers: authHeader() };
    return axios
        .post(`users/own/filled-survey-sessions/${sessionId}/submit-survey`, {
            survey_id: surveyId,
            filled_survey_id: filledSurveyId
        }, sett)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((err) => {
            var error = err.response;
            return Promise.reject(error);
        });
}